import { useMemo } from "react";

import { isEditable, isEditableDefinition } from "../../evergis/core/permissions";
import { usePostgresLayerWithTable } from "./usePostgresLayerWithTable";
import { useIsShared } from "../api/useIsShared";

export const useLayerEditable = (layerName: string): [boolean, boolean] => {
  const isShared = useIsShared();
  const { layer, table } = usePostgresLayerWithTable(layerName);

  return useMemo(
    () => [
      !isShared &&
        isEditable(layer.permissions) &&
        (isEditable(table.permissions) || layer.type === "QueryLayerService") &&
        isEditableDefinition(layer),
      !isShared && isEditable(layer.permissions) && layer.type === "ProxyService",
    ],
    [isShared, layer, table],
  );
};
